import React, {FC} from "react"
import {get} from "lodash"

import {BasketTotal, Deal} from "@irati/types"
import calculateTotals from "@irati/checkout/utils/basket/helper/calculateTotals"
import useBasket from "@irati/checkout/utils/basket/useBasket"
import {isFlexiCurrency} from "@shared/wallet"
import OrderSummaryTT from "./Summaries/OrderSummaryTT"
import OrderSummaryStd from "./Summaries/OrderSummaryStd"

interface Props {
  deal: Deal
  email: string
  discount?: BasketTotal
  cashback?: BasketTotal
  flexiPointsCashbackRate?: number
  showSavingOptions?: boolean
  isMobile?: boolean
  walletBalanceToUse?: number
}

const OrderSummary: FC<Props> = (props) => {
  const basket = useBasket()
  const {deal, walletBalanceToUse} = props
  const totals = calculateTotals(basket, walletBalanceToUse)
  const products = get(deal, "productConfig.products", [])

  return isFlexiCurrency(basket.breakdown.total?.currency) ? (
    <OrderSummaryTT {...props} basket={basket} totals={totals} products={products} />
  ) : (
    <OrderSummaryStd {...props} basket={basket} totals={totals} products={products} />
  )
}

export default OrderSummary
